import React, { FunctionComponent } from 'react';
import { Typography, TTypographyProps } from '@rbx/ui';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';
import { useReferenceTypesData } from './ReferenceTypesDataProvider';

export interface SimpleLinkableTypeReferenceProps {
  type: string;
  variant?: TTypographyProps['variant'];
  engineRevampEnabled?: boolean;
}

const SimpleLinkableTypeReference: FunctionComponent<
  React.PropsWithChildren<SimpleLinkableTypeReferenceProps>
> = ({ type, variant = 'code', engineRevampEnabled = false }) => {
  const { getTypeAliasDatumItem } = useReferenceTypesData();
  const trimmedType = type.trim();
  if (trimmedType === '') {
    return null;
  }
  let typeData;
  try {
    typeData = getTypeAliasDatumItem(trimmedType);
    if (!typeData) throw Error(`Missing type data for ${trimmedType}`);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    typeData = { canonicalLabel: trimmedType }; // renders a read-only string
  }
  const content = engineRevampEnabled ? (
    <span>{typeData.canonicalLabel}</span>
  ) : (
    <Typography variant={variant} color='inherit'>
      {typeData.canonicalLabel}
    </Typography>
  );
  return typeData.path ? (
    <DynamicallyRouted.Link
      href={typeData.path}
      color={engineRevampEnabled ? 'inherit' : 'primary'}>
      {content}
    </DynamicallyRouted.Link>
  ) : (
    content
  );
};

export default SimpleLinkableTypeReference;
